// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1EN35","label":"SetPasswdForm_label__Cvv0T"};